// src/entry/flows-main.jsx — Vite entry for flows.html.
// Extracted from flows.html inline <script type="text/babel"> on 2026-05-27.
// FlowsApp is attached to window.FlowsApp by components/FlowsApp.jsx;
// pulled into local scope here so the bare-name <FlowsApp /> JSX compiles.
//
// B6: FlowsApp renders its OWN <Footer> (and its OWN <main id="main-content">),
// so this entry mounts JUST <FlowsApp /> — a second <Footer> here duplicated the
// site footer, and flows.html's wrapper <main> nested a second landmark. The
// real footer + main landmark both live inside FlowsApp.

/* eslint-disable no-unused-vars */
const FlowsApp = window.FlowsApp;
/* eslint-enable no-unused-vars */

ReactDOM.createRoot(document.getElementById('root')).render(<FlowsApp />);
